import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  useTheme,
} from '@mui/material';
import { Block, ArrowBack } from '@mui/icons-material';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { AccountType } from '../types/auth';

const UnauthorizedPage: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user } = useAuthStore();

  const isRestrictedAdmin =
    user?.accountType !== undefined && user.accountType <= AccountType.User;

  if (isRestrictedAdmin) {
    return <Navigate to="/settings" replace />;
  }

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleRedirect = () => {
    navigate('/settings');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.grey[100],
      }}
    >
      <Container maxWidth="sm">
        <Paper
          sx={{
            p: 6,
            textAlign: 'center',
            borderRadius: 3,
            boxShadow: 3,
          }}
        >
          <Block
            sx={{
              fontSize: 80,
              color: theme.palette.error.main,
              mb: 3,
            }}
          />

          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{ fontWeight: 'bold', mb: 2 }}
          >
            Access Denied
          </Typography>

          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ mb: 4 }}
          >
            You don't have permission to access this page.
            Please contact your administrator if you need access.
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="outlined"
              startIcon={<ArrowBack />}
              onClick={handleGoBack}
              size="large"
            >
              Go Back
            </Button>

            <Button
              variant="contained"
              onClick={handleRedirect}
              size="large"
            >
              Settings
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default UnauthorizedPage;